const ProfissionSvg = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66634 3.33341V1.33341C3.66634 1.1566 3.73658 0.987034 3.8616 0.86201C3.98663 0.736986 4.1562 0.666748 4.33301 0.666748H9.66634C9.84315 0.666748 10.0127 0.736986 10.1377 0.86201C10.2628 0.987034 10.333 1.1566 10.333 1.33341V3.33341H12.9997C13.1765 3.33341 13.3461 3.40365 13.4711 3.52868C13.5961 3.6537 13.6663 3.82327 13.6663 4.00008V13.3334C13.6663 13.5102 13.5961 13.6798 13.4711 13.8048C13.3461 13.9298 13.1765 14.0001 12.9997 14.0001H0.999674C0.822863 14.0001 0.653294 13.9298 0.52827 13.8048C0.403246 13.6798 0.333008 13.5102 0.333008 13.3334V4.00008C0.333008 3.82327 0.403246 3.6537 0.52827 3.52868C0.653294 3.40365 0.822863 3.33341 0.999674 3.33341H3.66634ZM4.99967 8.66675H1.66634V12.6667H12.333V8.66675H8.99967V10.6667H4.99967V8.66675ZM12.333 4.66675H1.66634V7.33341H4.99967V6.00008H8.99967V7.33341H12.333V4.66675ZM6.33301 7.33341V9.33341H7.66634V7.33341H6.33301ZM4.99967 2.00008V3.33341H8.99967V2.00008H4.99967Z"
        fill="#00995D"
      />
    </svg>
  )
}

export default ProfissionSvg
